import { Appointment } from '@/types/appointments.types';
import { AppointmentsLifecycleEnum, AppointmentStatus } from '@/types/enums/appointments.enum';
import {
  MyAppointmentsDetailsOrigin,
  MyAppointmentsTabAba,
} from '@/types/enums/analytics/my-appointments/my-appointments-analytics.enum';

export const DETAILS_ORIGIN_PARAM = 'origem';
export const DETAILS_TAB_PARAM = 'aba';

export const TAB_BY_LIFECYCLE: Record<AppointmentsLifecycleEnum, MyAppointmentsTabAba> = {
  [AppointmentsLifecycleEnum.FUTURE]: MyAppointmentsTabAba.PROXIMOS,
  [AppointmentsLifecycleEnum.PAST]: MyAppointmentsTabAba.HISTORICO,
  [AppointmentsLifecycleEnum.OTHER]: MyAppointmentsTabAba.PENDENTES,
};

export function buildAppointmentDetailsHref(
  appointmentId: string,
  origin: MyAppointmentsDetailsOrigin,
  tab?: MyAppointmentsTabAba,
): string {
  const params = new URLSearchParams({ [DETAILS_ORIGIN_PARAM]: origin });

  if (tab) {
    params.set(DETAILS_TAB_PARAM, tab);
  }

  return `/agendamentos/${appointmentId}?${params.toString()}`;
}

export function readDetailsOrigin(value: string | null): MyAppointmentsDetailsOrigin {
  const origins: string[] = Object.values(MyAppointmentsDetailsOrigin);
  return value && origins.includes(value) ? value as MyAppointmentsDetailsOrigin : MyAppointmentsDetailsOrigin.DIRETO;
}

export function readDetailsTab(value: string | null): MyAppointmentsTabAba | undefined {
  const tabs: string[] = Object.values(MyAppointmentsTabAba);
  return value && tabs.includes(value) ? value as MyAppointmentsTabAba : undefined;
}

export function resolveDetailsLifecycle(
  appointment: Appointment,
  tab?: MyAppointmentsTabAba,
): AppointmentsLifecycleEnum {
  if (tab === MyAppointmentsTabAba.HISTORICO) {
    return AppointmentsLifecycleEnum.PAST;
  }

  if (tab === MyAppointmentsTabAba.PENDENTES) {
    return AppointmentsLifecycleEnum.OTHER;
  }

  if (appointment.status === AppointmentStatus.FINISHED) {
    return AppointmentsLifecycleEnum.PAST;
  }

  return AppointmentsLifecycleEnum.FUTURE;
}
